export default __webpack_public_path__ + "static/media/ic-unverified-location-large.eba1c552.svg";